<template>
  <div>
    <div class="pt-3 pl-3 pb-2" style="background-color: var(--bootstrapgrey); border-bottom-left-radius: 0px; border-top-left-radius: 0px;">
      <h3 class="section-title" style="text-transform: uppercase; font-weight: 400; color: #000;">Run Buddy Finder</h3>
      <!-- <button class="btn btn-primary" @click="showModal" style="float: right;">+ Add Training Week</button> -->
    </div>
    <!-- <p class="mt-3 ml-2" style="margin-bottom: 0;">It's always way more fun to run together! Share your upcoming training run with the team and see if one or two others can join you.</p>
    <p class="ml-2">Of course, keep your distance, keep each other safe, but let's also keep each other motivated and not stop running!</p> -->

    <div class="my-2 px-3 py-2" style="background-color: #ff7373; color: white;">
      <div v-if="team == 'MDI'" style="">
        <p class="mt-3 mx-2" style="margin-bottom: 0;">It's always way more fun to run together - especially during stressful times. Here's a way to share upcoming training runs with fellow Team Dynamo runners, and to see if 1-2 others can join you (maximum group size 3-4 till further notice!).</p>
        <p class="ml-2">Of course, strict adherence to current social/physical distancing rules apply (6 ft apart at all times) to keep each other safe, but let's also help each other stay motivated and not stop running!</p>
      </div>
      <div v-else>
        <p class="mt-3 ml-2" style="margin-bottom: 0;">It's always way more fun to run together! Share your upcoming training run with the team and see if one or two others can join you.</p>
        <p class="ml-2">Of course, keep your distance, keep each other safe, but let's also keep each other motivated and not stop running!</p>
      </div>
    </div>


    <button class="btn btn-primary mb-2 ml-1" @click="showModal">+ Post My Run</button>
    <div v-if="user.id" class="mb-3">
      <button v-if="!user.buddy_request_notifications" class="btn btn-primary mb-2 ml-1" @click="turnOnNotifications">Notify Me of New Runs Posted</button>
      <button v-if="user.buddy_request_notifications" class="btn btn-secondary mb-2 ml-1" @click="turnOffNotifications">Stop Notifying Me of New Runs</button>
    </div>

    <div v-if="buddyRequests[0]">
      <!-- {{ buddyRequests }} -->
      <!-- <app-map v-if="buddyRequests[0].city" :locationObject="buddyRequests[0]" class="mt-2"></app-map> -->
      <div v-for="request in buddyRequests" :key="request.id" style="overflow-wrap: break-word;" @click="showEditModal(request)">
        <!-- <app-map v-if="request.city" :locationObject="request" class="mt-2"></app-map> -->
        <div class="pt-3 pb-1 px-4 mb-1" style="background-color: var(--bootstrapgrey);">
          <!-- {{ request }} -->
          <h4>{{ request.first_name }} {{ request.last_name }}</h4>
          <hr>
          <div class="row">
            <div class="col-lg-6">
              <h5>Run Type</h5>
              <p>{{ request.workout }}</p>
              <h5>Location</h5>
              <p style="margin-bottom: 0;">{{ request.address }}</p>
              <p style="margin-bottom; 0;">{{ request.city }}, {{ request.provincestate }}, {{ request.country }}, {{ request.postal_code }}</p>
              <!-- <app-map v-if="request.city" :locationObject="request" class="mt-2"></app-map> -->
              <button class="btn btn-primary mb-4" @click="showMap(request)">View Map</button>
              <h5 v-if="request.description">Description</h5>
              <p>{{ request.description }}</p>
            </div>
            <div class="col-lg-6">
              <h5>When</h5>
              <p>{{ (new Date(request.date + 'T00:00:00')).toDateString() }}<span v-if="request.date && request.time"> - </span><span v-if="request.time">{{ djangotimeformatAMPM(request.time) }}</span><span v-if="request.recurring"> (I do this run regularly!)</span></p>
              <div class="row">
                <div class="col-md-6">
                  <h5>Planned Distance</h5>
                  <p v-if="request.distance && request.distance_units">{{ request.distance / getDistanceDivisor(request.distance_units) }} {{ request.distance_units }}</p>
                </div>
                <div class="col-md-6">
                  <h5>Planned Pace</h5>
                  <p>{{ convertSecondsToTime(request.pace).minutes }}:{{ convertSecondsToTime(request.pace).seconds }} per {{ request.pace_units }}</p>
                </div>
              </div>
              <h5>Contact Me!</h5>
              <p>{{ request.phone }}<span v-if="request.phone && request.email">, </span>{{ request.email }}</p>
              <!-- <h5>Description</h5>
              <p>{{ request.description }}</p> -->
            </div>
          </div>
          <hr>
          <button v-if="request.user == user.id" class="btn btn-danger mb-4" style="" @click="deleteRun(request)">Delete</button>
        </div>
        <!-- <hr> -->
      </div>
    </div>

    <!-- ---- BUDDY REQUEST MODAL ---- -->
    <modal name="buddy-request-modal" width="90%" height="auto" :scrollable="true" class="field-of-fields" style="z-index: 9999;">
      <div class="p-4" style="">
        <h4 v-if="!editing">Post Your Run</h4>
        <!-- <h4 v-if="editing">Edit {{ raceName }}</h4> -->
        <hr>
        <div class="row">
          <div class="col-lg-6 px-4">
            <h5 class="mb-3">What type of run are you doing?</h5>
            <select class="form-control" v-model="workout" style="">
              <option v-for="(workout, index) in workoutOptions" :key="'Workout'+index">{{ workout }}</option>
            </select>

            <h5 class="mt-4">Where are you going to run?</h5>
            <div class="form-group">
              <label>Address Line</label>
              <input type="text" class="form-control" v-model="address">
            </div>
            <!-- <div class="form-group">
              <label>Address Line 2</label>
              <input type="text" class="form-control" v-model="address2">
            </div> -->
            <div class="form-row form-group">
              <div class="col-md-6">
                <label>City</label>
                <input type="text" class="form-control" v-model="city">
              </div>
              <div class="col-md-6">
                <label>Postal Code</label>
                <input type="text" class="form-control" v-model="postalCode">
              </div>
            </div>
            <div class="form-row form-group">
              <div class="col-md-6">
                <label>Province</label>
                <input type="text" class="form-control" v-model="province">
              </div>
              <div class="col-md-6">
                <label>Country</label>
                <input type="text" class="form-control" v-model="country">
              </div>
            </div>

          </div>
          <div class="col-lg-6 px-4">
            <h5 class="mb-3">When are you going to run?</h5>
            <div class="form-row form-group mb-2">
              <div class="col-md-6">
                <datepicker class="form-control" placeholder="Select Date" v-model="date" :disabled-dates="disabledDates" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
              </div>
              <div class="col-md-6">
                <div class="input-group">
                  <select class="form-control" v-model="hour" style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                    <option>HH</option>
                    <option v-for="(hour, index) in hourOptions" :key="'Hour'+index">{{ hour }}</option>
                  </select>
                  <select class="form-control" v-model="minute">
                    <option>MM</option>
                    <option v-for="(minute, index) in minuteOptions" :key="'Minute'+index">{{ minute }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group form-check mt-2">
              <input class="form-check-input" type="checkbox" :value="true" v-model="recurring" style="">
              <label class="form-check-label ml-1" style="text-align: left; margin-top: 1px; cursor: pointer;" @click="recurring = !recurring">
                This is a run I do weekly
              </label>
            </div>

            <h5 class="mb-3 mt-4">About what distance do you plan to run?</h5>
            <div class="input-group">
              <input type="text" class="form-control" v-model="distance">
              <select class="form-control" v-model="distanceUnits">
                <option>km</option>
                <option>mi</option>
              </select>
            </div>

            <h5 class="mb-3 mt-4">About what pace do you plan to run at?</h5>
            <div class="input-group">
              <input type="text" class="form-control" v-model="paceMinutes" placeholder="min">
              <input type="text" class="form-control" v-model="paceSeconds" placeholder="sec">
              <select class="form-control" v-model="paceUnits">
                <option>km</option>
                <option>mi</option>
              </select>
            </div>

            <h5 class="mt-4 mb-1">How can someone contact you to coordinate?</h5>
            <div class="form-row form-group">
              <div class="col-md-6">
                <label>Email</label>
                <input type="text" class="form-control" v-model="email">
              </div>
              <div class="col-md-6">
                <label>Phone</label>
                <input type="text" class="form-control" v-model="phone">
              </div>
            </div>
          </div>
          <div class="col-lg-12 px-4">
            <label>Description - Anything else people should know about your run?</label>
            <textarea class="form-control" rows="3" v-model="description"></textarea>
          </div>
        </div>
        <hr>
        <button class="btn btn-primary mb-4" style="float: right;" @click="postRun">Post Your Run</button>
      </div>
    </modal>
    <!-- ---- END OF BUDDY REQUEST MODAL ---- -->

    <modal name="map-modal" width="90%" height="auto" :scrollable="true" class="field-of-fields" style="z-index: 9999;">
      <div>
        <app-map v-if="request.city" :locationObject="request" class=""></app-map>
      </div>
    </modal>

  </div>
</template>

<script>

import axios from 'axios'
import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker
import Map from '../global/Map.vue';

export default {
  data () {
    return {
      team: '',
      buddyRequests: [],
      request: {},

      user: {},
      firstName: '',
      lastName: '',
      phone: '',
      email: '',

      workout: '',
      workoutOptions: [],

      address: '',
      city: '',
      province: '',
      country: '',
      postalCode: '',

      date: null,
      hourOptions: [],
      minuteOptions: [],
      hour: 'HH',
      minute: 'MM',

      distance: null,
      distanceUnits: '',
      paceMinutes: null,
      paceSeconds: null,
      paceUnits: '',

      description: '',
      recurring: false,

      editing: false,

      notify: false,
    }
  },
  components: {
    Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
    appMap: Map,
  },
  created () {
    this.hourOptions = this.$store.getters.hourOptions
    this.minuteOptions = this.$store.getters.minuteOptions
    this.workoutOptions = this.$store.getters.MDIworkouts

    // this.$store.dispatch('getUser').then(() => { // Lecture 360
    //   this.user = this.$store.getters.user
    //   console.log(this.$store.getters.user)
    // })
    this.getUserProfile();

    this.team = this.$store.getters.team
  },
  computed: {
    disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      let today = new Date()
      let disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      }
      return disabledDates
    },
  },
  methods: {
    getUserProfile () {
      axios.get('/api/users/?id='.concat(this.$store.getters.userID))
        .then(res => {
          this.user = res.data[0]
          // this.distanceUnits = this.user.preferred_distance_units
          this.phone = this.user.cell_phone
          this.email = this.user.email

          // this.address = this.user.address1
          this.city = this.user.city
          this.province = this.user.provincestate
          this.country = this.user.country
          this.postalCode = this.user.postal_code

          this.distanceUnits = this.user.preferred_distance_units
          this.paceUnits = this.user.preferred_distance_units

          this.notify = this.user.buddy_request_notifications

          this.getBuddyRequests();
        })
        .catch(error => console.log(error))

      // // userID is a prop, the idea being that it can be passed in via the coach's dashboard or elsewhere to view anyone's training plan
      // // If it's not passed in, then we just get the training plan of whoever is logged in
      // if (!this.userID) {
      //   this.$store.dispatch('getUser').then(() => { // Lecture 360
      //     this.user = this.$store.getters.user
      //     this.distanceUnits = this.user.preferred_distance_units
      //     console.log(this.$store.getters.user)
      //     this.getPastRaces();
      //   })
      // }
      // else {
      //   axios.get('/api/users/?id='.concat(this.userID))
      //     .then(res => {
      //       this.user = res.data[0]
      //       this.distanceUnits = this.user.preferred_distance_units
      //       this.getPastRaces();
      //     })
      //     .catch(error => console.log(error))
      // }
    },
    getBuddyRequests() {
      axios.get('/api/buddyrequests/?team='.concat(this.team))
        .then(res => {
          console.log(res)
          this.buddyRequests = res.data
        })
        .catch(error => console.log(error))
    },
    showModal() {
      // this.clearRaceForm()
      this.editing = false

      this.workout = ''
      this.date = null
      this.hour = 'HH'
      this.minute = 'MM'

      this.distance = null
      this.paceMinutes = null
      this.paceSeconds = null

      this.description = ''
      this.recurring = false

      this.$modal.show('buddy-request-modal'); // npmjs.com/package/vue-js-modal
    },
    hideModal() {
      // this.clearRaceForm()
      this.editing = false
      this.$modal.hide('buddy-request-modal'); // npmjs.com/package/vue-js-modal
    },
    postRun () {
      // this.saveClicked = true
      // console.log(this.raceDate)
      // // console.log(this.raceDate.format("isoDate"))
      // // let options = { year: 'numeric',  }
      // let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      // console.log(this.raceDate.toLocaleDateString("en-US", options)); // 9/17/2016

      // if (!this.distanceUnits){
      //   this.distanceUnits = this.user.preferred_distance_units
      // }

      // // if (this.raceType == '5k')
      // this.calculateDistance();
      // this.calculateTotalTime();

      // Need to get the time into the format hh:mm:ss
      let time = null
      if (this.hour != 'HH') {
        time = this.hour
        if (this.minute != 'MM') {
          time += (':' + this.minute + ':00')
        }
        else {
          time += (':00:00')
        }
      }

      let paceinseconds = null
      if (this.paceMinutes && this.paceSeconds) {
        paceinseconds = this.convertTimeToSeconds(0, this.paceMinutes, this.paceSeconds)
      }

      // Need to get the date in the format YYYY-MM-DD
      if (this.date) {
        this.date =
          this.date.getFullYear().toString() +
          // https://stackoverflow.com/questions/8169785/how-to-prepend-a-zero-in-front-of-any-number-below-10-in-javascript-using-regexp
          '-' + ('0' + (this.date.getMonth()+1).toString()).slice(-2) +
          '-' + ('0' + this.date.getDate().toString()).slice(-2)
      }

      axios.post('/api/buddyrequests/',
        {
          user: this.user.id, // https://stackoverflow.com/questions/39001486/posting-a-foreign-key-relationship-in-django-rest-framework
          team: this.team,
          first_name: this.user.first_name,
          last_name: this.user.last_name,

          email: this.email,
          phone: this.phone,

          workout: this.workout,

          address: this.address,
          postal_code: this.postalCode,
          city: this.city,
          provincestate: this.province,
          country: this.country,

          distance: this.convertDistanceToMeters(this.distance, this.distanceUnits),
          distance_units: this.distanceUnits,

          pace: paceinseconds,
          pace_units: this.paceUnits,

          time: time,
          date: this.date,

          description: this.description,

          recurring: this.recurring,
        }
      )
        .then(res => {
          console.log(res)
          this.getBuddyRequests() // Refresh the list of races after adding a new one
          // this.clearRaceForm()
          this.hideModal() // Close the race modal
          // this.saveClicked = false
        })
        .catch(error => console.log(error))
    },
    deleteRun(request) {
      axios.delete('/api/buddyrequests/'+request.id.toString()+'/')
        .then(res => {
          console.log(res)
          this.getBuddyRequests()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDistanceDivisor(units) {
      if (units == 'km') {
        return 1000
      }
      else if (units == 'mi') {
        return 1609
      }
      else {
        return 1
      }
    },
    showMap(request) {
      this.request = request
      this.$modal.show('map-modal')
    },
    turnOnNotifications() {
      axios.patch('/api/users/'+this.user.id.toString()+'/', {
        buddy_request_notifications: true
      })
        .then(res => {
          this.getUserProfile()
        })
        .catch(error => {
          console.log(error)
        })
    },
    turnOffNotifications() {
      axios.patch('/api/users/'+this.user.id.toString()+'/', {
        buddy_request_notifications: false
      })
        .then(res => {
          this.getUserProfile()
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/myrundash/BuddyFinder.vue